import React, { Component } from 'react';
import SideNav, {
  Toggle,
  Nav,
  NavItem,
  NavIcon,
  NavText,
} from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';

import Dropdown from 'react-bootstrap/Dropdown';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import Alert from 'react-bootstrap/Alert';

// My componennts
import SearchItems from '../software_pages/serach_software/SearchItems';
import MyReviewList from './MyReviewList';
import MyQAList from './MyQAList';

var firebase = require('firebase/app');
// Add the Firebase products that you want to use
require('firebase/auth');
require('firebase/firestore');
var Link = require('react-router-dom').Link;

/**
 * Handles the my account page: retrieving the user's created data (pages, reviews, qas)
 * and displaying them
 */
class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.retrieveMyPages = this.retrieveMyPages.bind(this);
    this.retrieveMyReviews = this.retrieveMyReviews.bind(this);
    this.retrieveMyQAs = this.retrieveMyQAs.bind(this);
    this.deleteReviewFromUser = this.deleteReviewFromUser.bind(this);
    this.incrementSofties = this.incrementSofties.bind(this);
    this.getTitle = this.getTitle.bind(this);
    this.getReviews = this.getReviews.bind(this);
    this.getQAs = this.getQAs.bind(this);
    this.displayUserMessage = this.displayUserMessage.bind(this);

    this.db = firebase.firestore();

    this.state = {
      displayName: '',
      accType: '',
      softies: 0,
      email: '',
      pages: [],
      pagesLeft: 0,
      reviews: [],
      reviewCount: 0,
      qas: [],
      qaCount: 0,
      pagesData: [], // Potential optimization, instead of individual loading, all load here
      reviewsData: [],
      userMessage: '',
    };
  }

  componentDidMount() {
    let _this = this;
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        _this.setState({ accType: user.photoURL });
        _this.db
          .collection('user_accounts')
          .doc(user.email)
          .get()
          .then(doc => {
            if (doc.exists) {
              let docData = doc.data();
              _this.setState({
                displayName: docData.displayName,
                softies: docData.softies,
                pagesLeft: docData.pagesLeft,
                email: docData.email,
                pages: docData.pages,
                reviews: docData.reviews,
                reviewCount: docData.reviews.length,
                qas: docData.qas,
                qaCount: docData.qas.length,
                userMessage: docData.userMessage,
              });
            }
          })
          .catch(function (error) {
            console.log('Error getting documents: ', error);
          });
      }
    });
  }

  // Functions passed on as props to be called
  deleteReviewFromUser = revId => {
    let _this = this;
    this.db
      .collection('user_accounts')
      .doc(this.state.email)
      .update({
        reviews: _this.state.reviews.filter(id => id !== revId),
      });
  };

  incrementSofties(amount) {
    if (amount) {
      this.setState({ softies: this.state.softies + amount });
    }
  }

  // Retrieving the various data from the user in order to avoid cluttering up the render call
  retrieveMyPages() {
    return (
      <SearchItems
        productIds={this.state.pages}
        userItem={true}
        incrementSofties={this.incrementSofties}
        mySearchItems={true}
      />
    );
  }

  retrieveMyReviews() {
    return (
      <MyReviewList
        reviews={this.state.reviews}
        deleteReviewFromUser={this.deleteReviewFromUser}
        incrementSofties={this.incrementSofties}
      />
    );
  }

  retrieveMyQAs() {
    return (
      <MyQAList
        qas={this.state.qas}
        deleteReviewFromUser={this.deleteReviewFromUser}
        incrementSofties={this.incrementSofties}
      />
    );
  }

  // These content items need different actions based on the state: handle this
  getTitle() {
    return this.state.accType === 'user' ? (
      <h4> {this.state.displayName} </h4>
    ) : (
      <h4>
        {' '}
        {this.state.displayName} <Badge variant="secondary">DEV</Badge>{' '}
      </h4>
    );
  }

  getReviews() {
    return this.state.accType === 'user' ? (
      <div>
        <Alert variant={'secondary'}>
          <div stlye={headerMain}>
            My Reviews
            <Badge>
              <p style={createPageAlignTopRight}>
                {' '}
                {`${this.state.reviewCount} reviews`}{' '}
              </p>
            </Badge>
          </div>
        </Alert>
        <br />
        <this.retrieveMyReviews />
        <br />
      </div>
    ) : (
      <div></div>
    );
  }

  getQAs() {
    return this.state.accType === 'user' ? (
      <div>
        <Alert variant={'secondary'}>
          <div stlye={headerMain}>
            My QAs
            <Badge>
              <p style={createPageAlignTopRight}>
                {' '}
                {`${this.state.qaCount} QAs`}{' '}
              </p>
            </Badge>
          </div>
        </Alert>
        <br />
        <this.retrieveMyQAs />
        <br />
      </div>
    ) : (
      <div>
        <Alert variant={'info'}>
          <Badge>INFO</Badge>Looking for Reviews and QAs? Only users are allowed
          to do that!
        </Alert>
      </div>
    );
  }

  displayUserMessage() {
    return this.state.userMessage !== '' ? (
      <Alert variant="danger">{this.state.userMessage} </Alert>
    ) : (
      <div></div>
    );
  }

  render() {
    return (
      <div className="container">
        <this.displayUserMessage />
        <div style={headerMain}>
          <this.getTitle />
          <i style={alignTopRight}> {this.state.softies} softies </i>
        </div>
        <Dropdown.Divider />
        <h6 style={{ margin: '0px 0px 0px 4px' }}>
          {' '}
          Welcome to your account!{' '}
        </h6>
        <br />
        <Alert variant={'secondary'}>
          <div stlye={headerMain}>
            My Pages
            <Badge style={createPageAlignTopRight}>
              <Link to="/create_product">
                {' '}
                {`Pages left: ${this.state.pagesLeft}`}{' '}
              </Link>{' '}
            </Badge>
          </div>
        </Alert>
        <this.retrieveMyPages />
        <br />
        <this.getReviews />
        <this.getQAs />
        <br />
        <br /> <br /> <br /> <br />
      </div>
    );
  }
}

const sideNavStyle = {
  margin: '50px 0px 0px 0px',
};

const headerMain = {
  position: 'relative',
};

const alignTopRight = {
  position: 'absolute',
  top: '3px',
  right: '12px',
};

const createPageAlignTopRight = {
  position: 'absolute',
  top: '4px',
  right: '5px',
};

export default Dashboard;
